import React, { memo } from 'react';

// Memoized Background to prevent re-renders on input
const AnimatedBackground = memo(() => (
  <div className="animated-bg">
    <div className="shape shape-1"></div>
    <div className="shape shape-2"></div>
    <div className="shape shape-3"></div>
    <div className="shape shape-4"></div>
    <div className="shape shape-5"></div>

    <style>{`
      .animated-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
        overflow: hidden;
        z-index: 0;
      }
      .shape {
        position: absolute;
        opacity: 0.15;
        background: white;
        border-radius: 4px;
        animation: float 20s infinite linear;
      }
      .shape-1 { width: 100px; height: 100px; top: 10%; left: 10%; animation-delay: 0s; }
      .shape-2 { width: 150px; height: 150px; top: 70%; left: 80%; animation-delay: -5s; }
      .shape-3 { width: 80px; height: 80px; top: 40%; left: 60%; animation-delay: -10s; }
      .shape-4 { width: 120px; height: 120px; top: 80%; left: 20%; animation-delay: -15s; }
      .shape-5 { width: 200px; height: 200px; top: 20%; left: 80%; animation-delay: -8s; }

      @keyframes float {
        0% { transform: translateY(0) rotate(0deg); }
        50% { transform: translateY(-20px) rotate(180deg); }
        100% { transform: translateY(0) rotate(360deg); }
      }
    `}</style>
  </div>
));

const AuthLayout = ({ children, title, subtitle }) => {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative'
    }}>
      <AnimatedBackground />

      <div className="auth-card" style={{ zIndex: 1, width: '100%', maxWidth: '460px' }}>
        <div className="card" style={{
          border: 'none',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)'
        }}>
          <div className="text-center mb-4">
            <h1 className="app-brand-text mb-2">Medoro</h1>
            <h2 className="h5 text-muted fw-medium">{title}</h2>
            {subtitle && <p className="text-secondary small mb-0">{subtitle}</p>}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
